import React from 'react';
import { formatCurrency } from '@/lib/fmUtils';

/**
 * ProgressBarWithLabel - horizontal progress bar with formatted value/max text.
 * Props:
 *   value  - current numeric value
 *   max    - target/maximum numeric value
 *   format - "currency" | "percentage" | "count"
 *   label  - optional label text
 */
export default function ProgressBarWithLabel({ value = 0, max = 0, format = 'count', label }) {
  const numValue = Number(value) || 0;
  const numMax = Number(max) || 0;
  const pct = numMax > 0 ? Math.min((numValue / numMax) * 100, 100) : 0;

  // Format value based on type
  const formatValue = (v) => {
    if (format === 'currency') return formatCurrency(v);
    if (format === 'percentage') return `${Math.round(v)}%`;
    return String(Math.round(v));
  };

  // Bar color based on progress
  let barColor = 'bg-yellow-500';
  if (numMax > 0 && numValue >= numMax) {
    barColor = 'bg-green-500';
  } else if (numMax > 0 && numValue < numMax * 0.5) {
    barColor = 'bg-red-500';
  }

  return (
    <div className="w-full">
      {/* Value / Max text */}
      <div className="flex items-center justify-between text-xs text-slate-600 mb-1">
        <span>
          {formatValue(numValue)} / {formatValue(numMax)}
        </span>
        {label && <span className="text-slate-400">{label}</span>}
      </div>

      {/* Progress bar */}
      <div className="h-2 rounded-full bg-slate-200 overflow-hidden">
        <div
          className={`h-2 rounded-full transition-all duration-500 ${barColor}`}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
